module.exports = "https://coursera_assets.s3.amazonaws.com/images/dae67a579a6ef4615f54d66f3ab8cc1d.png";